/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const NavTogglerSquare = ({ className }) => (
  <svg
    className={className}
    version="1.2"
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    fill="currentColor"
    height="18"
    width="13"
  >
    <path d="M0 252.9h147.1V400H0zM0 0h147.1v147.1H0zM252.9 0H400v147.1H252.9zM252.9 252.9H400V400H252.9z" />
  </svg>
);

export default NavTogglerSquare;
